/**
 * Turn any YouTube URL into an /embed/ URL usable in an iframe.
 * Accepts: youtu.be/xxx, youtube.com/watch?v=xxx, /embed/xxx, /shorts/xxx,
 * or a raw 11-character video ID. Returns null when the input is empty or
 * unrecognised.
 */
export function toYouTubeEmbed(url) {
  if (!url) return null;
  const s = String(url).trim();
  try {
    const u = new URL(s);
    if (u.hostname.includes("youtu.be")) {
      const id = u.pathname.replace(/^\//, "").split("/")[0];
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (u.hostname.includes("youtube.com")) {
      if (u.pathname.startsWith("/embed/")) return `https://www.youtube.com${u.pathname}`;
      if (u.pathname.startsWith("/shorts/")) {
        const id = u.pathname.split("/")[2];
        return id ? `https://www.youtube.com/embed/${id}` : null;
      }
      const v = u.searchParams.get("v");
      return v ? `https://www.youtube.com/embed/${v}` : null;
    }
  } catch { /* not a URL — treat as raw video ID */ }
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return `https://www.youtube.com/embed/${s}`;
  return null;
}
